import { render, staticRenderFns } from "./CompanyProducts.vue?vue&type=template&id=5fb200a5"
import script from "./CompanyProducts.vue?vue&type=script&lang=js"
export * from "./CompanyProducts.vue?vue&type=script&lang=js"
import style0 from "./CompanyProducts.vue?vue&type=style&index=0&id=5fb200a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports